import promise from 'es6-promise';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
promise.polyfill();
import Vue from 'vue';
import App from './App.vue';
import router from './router'; //路由
import ElementUI from 'element-ui'; //el
import 'element-ui/lib/theme-chalk/index.css'; //el样式表
import store from '@/store'; //vuex
// import '@/assets/css/eduBase.css'; //基础样式表
import eventBus from '@/utils/eventBus'; //消息组件
Vue.prototype.$eventBus = eventBus;
import windowSizeMixin from '@/mixins/windowSizeMixin'; //混入-浏览器窗口监听
import * as echarts from 'echarts'; // 在import的后面，echarts的前面加一个 * as
//import { commonUserDocById } from "../../../api/financing";
import { commonUserDocById } from "./api/financing";
import Clipboard from 'v-clipboard';
import Spreadsheet from "x-data-spreadsheet";
import zhCN from "x-data-spreadsheet/dist/locale/zh-cn";

Spreadsheet.locale("zh-cn", zhCN);
import VueMarquee from 'vue-marquee-component';

Vue.use(VueMarquee);
Vue.prototype.$echarts = echarts;
import MarkdownIt from 'markdown-it';

import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)

import { initLogin } from '@/assets/js/LoginConfig.js';
// 创建 markdown-it 实例
const md = new MarkdownIt({
    // Markdown解析器配置
    html: true,
    xhtmlOut: true,
    breaks: true,
    linkify: true,
    typographer: true,
})
// 添加全局过滤器或方法
Vue.prototype.$md = (text) => md.render(text);
// getUrlParams(url) {
//   const paramsRegex = /[?&]+([^=&]+)=([^&]*)/gi;
//   const params = {};
//   let match;
//   while (match = paramsRegex.exec(url)) {
//     params[match[1]] = match[2];
//   }
//   return params;
// }
Vue.prototype.$pdfClick = (item) => {
    let data = {
        token: localStorage.getItem("token") || "",
        docId: item.docid || item.code.split('_')[1],
        uid: item.uid,
        leafId: item.leafid,
        chnid: item.chnid
    }
    commonUserDocById(data).then(res => {
        if (res.status == 200) {
            if (res.data.data.attachment.data != null) {
                let attachmentName = res.data.data.attachment.data.attachmentName
                if (attachmentName.endsWith(".pdf") > 0) {
                    // 跳转预览页面
                    // router.push({
                    //   path: "/detailPages",
                    //   query: { docId: item.code.split('_')[1], uid: item.uid, leafId: item.leafid, chnid: item.chnid }
                    // });
                    sessionStorage.setItem(
                        "navSubIndex",
                        JSON.stringify({ uid: "", text: '文章' })
                    );
                    const routeUrl = router.resolve({
                        path: "/detailPages",
                        query: { docId: item.docid || item.code.split('_')[1], uid: item.uid, leafId: item.leafid, chnid: item.chnid }
                    })
                    //window.open(routeUrl.href, '_blank')
                    const a = document.createElement('a');
                    const id = 'newpage'
                    const url = routeUrl.href
                    a.setAttribute('href', url);
                    a.setAttribute('target', '_blank');
                    a.setAttribute('id', id);
                    // 防止反复添加
                    if (!document.getElementById(id)) {
                        document.body.appendChild(a);
                    }
                    a.click();
                } else {
                    // 跳转详情页
                    const url = 'https://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx' + '?chnid=' + item.chnid + '&leafid=' + item.leafid + '&docid=' + item.code.split('_')[1] + '&uid=' + item.uid
                    setTimeout(() => {
                        window.open(url, "_blank");
                    }, 500);
                }
            } else {
                // 跳转详情页
                const url = 'https://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx' + '?chnid=' + item.chnid + '&leafid=' + item.leafid + '&docid=' + item.code.split('_')[1] + '&uid=' + item.uid
                setTimeout(() => {
                    window.open(url, "_blank");
                }, 500);
            }
        }
    })
}
if (process.env.NODE_ENV === 'production') {
    if (window) {
        window.console.log = function () { };
    }
}
Vue.mixin(windowSizeMixin);
Vue.use(ElementUI);
Vue.use(Clipboard);
// 检测是否是 IE 浏览器
const isIE =
    /msie|trident/i.test(navigator.userAgent) &&
    !/opera/i.test(navigator.userAgent);
if (isIE) { } else {
    // 如果不是 IE 浏览器，正常加载应用
    new Vue({
        render: (h) => h(App),
        router,
        store,
    }).$mount('#app');
}